import { render, staticRenderFns } from "./SiStaFacendoAstaPer.vue?vue&type=template&id=1d66f338&scoped=true&"
import script from "./SiStaFacendoAstaPer.vue?vue&type=script&lang=js&"
export * from "./SiStaFacendoAstaPer.vue?vue&type=script&lang=js&"
import style0 from "./SiStaFacendoAstaPer.vue?vue&type=style&index=0&id=1d66f338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66f338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d66f338')) {
      api.createRecord('1d66f338', component.options)
    } else {
      api.reload('1d66f338', component.options)
    }
    module.hot.accept("./SiStaFacendoAstaPer.vue?vue&type=template&id=1d66f338&scoped=true&", function () {
      api.rerender('1d66f338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SiStaFacendoAstaPer.vue"
export default component.exports